export const dayToSecond = (day: number) => 60 * 60 * 24 * day;
